import * as React from "react";
import { SVGProps } from "react";
const SvgLogoNscale = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={16}
    height={9}
    {...props}
  >
    <defs>
      <clipPath id="logo-nscale_svg__b">
        <path d="M0 0h16v9H0z" />
      </clipPath>
      <clipPath id="logo-nscale_svg__c">
        <path d="M0 0h16v9H0z" />
      </clipPath>
      <mask id="logo-nscale_svg__e">
        <g filter="url(#logo-nscale_svg__a)">
          <path
            style={{
              fill: "#000",
              fillOpacity: 0.6,
              stroke: "none",
            }}
            d="M0 0h16v9H0z"
          />
        </g>
      </mask>
      <mask id="logo-nscale_svg__g">
        <g filter="url(#logo-nscale_svg__a)">
          <path
            style={{
              fill: "#000",
              fillOpacity: 0.4,
              stroke: "none",
            }}
            d="M0 0h16v9H0z"
          />
        </g>
      </mask>
      <g id="logo-nscale_svg__d" clipPath="url(#logo-nscale_svg__b)">
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#111218",
            fillOpacity: 1,
          }}
          d="M2.758 8.957c-.16 0-.238-.203-.125-.32l5.492-5.801c.32-.34.84-.34 1.164 0 .32.34.32.887 0 1.227L4.891 8.694a.822.822 0 0 1-.602.262Zm0 0"
        />
      </g>
      <g id="logo-nscale_svg__f" clipPath="url(#logo-nscale_svg__c)">
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#111218",
            fillOpacity: 1,
          }}
          d="M.426 8.96c-.38 0-.567-.483-.301-.765l3.34-3.527c.32-.34.84-.34 1.164 0 .32.34.32.887 0 1.227l-2.66 2.8a.818.818 0 0 1-.602.266Zm0 0"
        />
      </g>
      <filter
        id="logo-nscale_svg__a"
        filterUnits="objectBoundingBox"
        x="0%"
        y="0%"
        width="100%"
        height="100%"
      >
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
      </filter>
    </defs>
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#111218",
        fillOpacity: 1,
      }}
      d="M15.035.988c0-.863-.984-1.293-1.566-.687L5.527 8.637c-.113.12-.035.324.125.324h1.149c.054 0 .11-.004.164-.012l1.77-.285a10.243 10.243 0 0 1 3.382.02l1.5.261a.841.841 0 0 0 .176.016h.805a.45.45 0 0 0 .437-.461Zm0 0"
    />
    <use xlinkHref="#logo-nscale_svg__d" mask="url(#logo-nscale_svg__e)" />
    <use xlinkHref="#logo-nscale_svg__f" mask="url(#logo-nscale_svg__g)" />
  </svg>
);
export default SvgLogoNscale;
